import { CoursesDocument, useCoursesQuery } from 'api/generated';
import { getBaseOptions } from 'api/wrappers';
export const useCoursesQueryApi = (variables, options) => {
    const { data, ...rest } = useCoursesQuery(getBaseOptions(variables, options));
    const courses = (data?.schoolYear?.courses ?? [])
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name));
    return { ...rest, data: courses };
};
export const getCreateCourseMutationOptions = (course) => ({
    refetchQueries: [CoursesDocument],
    variables: {
        input: course,
    },
});
export const getUpdateCourseMutationOptions = (course) => ({
    variables: {
        input: course,
    },
});
export const getDeleteCourseMutationOptions = (id) => ({
    refetchQueries: [CoursesDocument],
    variables: {
        id,
    },
});
export { useCreateCourseMutation } from 'api/generated';
export { useUpdateCourseMutation } from 'api/generated';
export { useDeleteCourseMutation } from 'api/generated';
